import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

import { UploadRequest } from '../models/uploadRequest';

@Injectable()
export class CompanyService {
  constructor(private http: Http, private httpClient: HttpClient) {}

  private baseurl = environment.apiBaseUrl;

  // save an entry into company table when a new company is added by on click add company
  saveCompany(data) {
    return this.http.post(`${this.baseurl}/company/save`, data).map((res: Response) => res.json());
  }

  // update company name onchange event
  updateCompany(companyId, data) {
    return this.http
      .post(`${this.baseurl}/company/update`, { companyId, data })
      .map((response: Response) => response.json());
  }

  // get all companies from company table
  getCompanies(id) {
    return this.http
      .post(`${this.baseurl}/company/getCompanies`, {
        userid: id,
      })
      .map((res: Response) => res.json());
  }

  // get single company from db
  getCompany(companyId) {
    return this.http
      .post(`${this.baseurl}/company/get`, { companyId })
      .map((res: Response) => res.json());
  }

  // delete company from db when trash button of company is clicked
  deleteComapny(companyId) {
    //
    // There is no JSON returned by this API, just the HTTP status.
    //
    return this.http.post(`${this.baseurl}/company/delete`, { companyId });
  }

  getLogoUploadUrl(companyId: string, fileType: string): Observable<UploadRequest> {
    return this.httpClient.get<UploadRequest>(
      `${this.baseurl}/companies/${companyId}/logoUploadUrl`,
      {
        params: new HttpParams().set('fileType', fileType),
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/company.service.ts